<app-modal [header]="'admintool.title.multiple_articles_with_same_no_found' | translate : {'0': articles[0]?.articleNo}">
  <div modal-body class="d-flex flex-column gap-2">
    <span>{{ 'admintool.message.multiple_articles_with_same_no_found' | translate }}</span>
    @for (article of articles; track $index) {
      <div class="article selectable d-flex flex-column gap-1 p-2" (click)="selectArticle(article)">
        <b>ID: {{ article.identity }}</b>
        <div class="d-flex gap-2">
          <div class="d-flex flex-column">
            @if (article.articleNote) {
              <span><b>{{ 'sidebar.article_data.comment_tab' | translate }}:</b> {{ article.articleNote }}</span>
            }
            <span class="small">{{ displayNames[$index] }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</app-modal>
